import { createSelector } from 'reselect';
import { getSelectedOrganization } from 'helpers/selectors';
import { createErrorDataSelector } from 'selectors/selectorUtils';


const getEventLogs = ({ eventLog }) => {
    return eventLog.eventLogs?.events || [];
};

const getEventLogFiltersRaw = ({ eventLog }) => eventLog.filters;
const getDateKindRaw = ({ eventLog }) => eventLog.dateKind;

const getFilters = createSelector(
    [getEventLogFiltersRaw, getDateKindRaw],
    (filters, dateKind) => ({ ...filters, dateKind })
);

const getEventLogLoadingStatus = ({ eventLog }) => {
    return eventLog.eventLogLoadingStatus;
};

const getEventClosingLoadingStatus = ({ eventLog }) => {
    return eventLog.eventClosingLoadingStatus;
};

const getEventClosingError = ({ eventLog }) => {
    return eventLog.eventClosingError;
};

const getIsTruncated = ({ eventLog }) => {
    return eventLog.isTruncated;
};

const getSelectedAssets = ({ eventLog }) => {
    return eventLog.selectedAssets;
};

const getUser = ({ overview }) => {
    return overview.user?.data;
};

const getEventGroupName = ({ eventLog }) => {
    return eventLog?.expandedEventGroup;
};

const getEventClosingRawError = createSelector([
    getEventClosingLoadingStatus,
    getEventClosingError
], (loadingStatus, error) => {
    return {
        loadingStatus,
        error,
        errorCode: error?.statusCode
    };
});

const getEventClosingErrorData = createErrorDataSelector(getEventClosingRawError);

export const getModel = createSelector([
    getEventLogs,
    getFilters,
    getEventLogLoadingStatus,
    getEventClosingLoadingStatus,
    getIsTruncated,
    getSelectedOrganization,
    getSelectedAssets,
    getUser,
    getEventGroupName,
    getEventClosingErrorData
],
    (
        eventLogs,
        filters,
        eventLogLoadingStatus,
        eventClosingLoadingStatus,
        isTruncated,
        organizationID,
        selectedAssets,
        user,
        eventGroupName,
        eventClosingErrorData
    ) => {
        return {
            eventLogs,
            filters,
            eventLogLoadingStatus,
            eventClosingLoadingStatus,
            isTruncated,
            organizationID,
            selectedAssets,
            user,
            eventGroupName,
            eventClosingErrorData
        };
    });
